<template>
  <div>
    <div v-if="startOfMonth" style="background-color: #212121" class="white--text">
      <v-card-title class="font-weight-bold">Überblick Center</v-card-title>
      <v-row no-gutters>
        <v-col cols="auto">
          <v-card class="mx-2 white--text mt-2 pa-1 rounded-lg text-center" color="#00c9a7">
            <v-card-title class="font-weight-bold justify-content-center"
              >Mitglieder ({{ $moment(datePickerRange[0]).format("DD.MMM") }})</v-card-title
            >
            <span class="h4 font-weight-bold">
              <number :to="startOfMonth.customersAmount.tac.customers.total"></number>
            </span>
          </v-card>
        </v-col>
        <v-col cols="auto">
          <v-card class="mx-2 white--text mt-2 pa-1 rounded-lg text-center" color="red">
            <v-card-title class="font-weight-bold justify-content-center">Kündigungen </v-card-title>
            <span v-if="finishedLoadingTerminations" class="h4 font-weight-bold"> <number :to="terminations"></number></span>
            <div v-else>
              <v-progress-circular indeterminate color="white"></v-progress-circular>
            </div>
          </v-card>
        </v-col>
        <v-col cols="auto">
          <v-card class="mx-2 white--text mt-2 pa-1 rounded-lg text-center" color="primary">
            <v-card-title class="font-weight-bold justify-content-center">Neu Verträge </v-card-title>
            <span v-if="finishedLoading" class="h4 font-weight-bold"> <number :to="newContracts.totalContracts"></number></span>
            <div v-else>
              <v-progress-circular indeterminate color="white"></v-progress-circular>
            </div>
          </v-card>
        </v-col>
        <v-col cols="auto">
          <v-card class="mx-2 white--text mt-2 pa-1 rounded-lg text-center" color="orange">
            <v-card-title class="font-weight-bold justify-content-center">Online Verträge </v-card-title>
            <span v-if="finishedLoading" class="h4 font-weight-bold"> <number :to="newContracts.publicContracts"></number></span>
            <div v-else>
              <v-progress-circular indeterminate color="white"></v-progress-circular>
            </div>
          </v-card>
        </v-col>
        <v-col cols="auto">
          <v-card class="mx-2 white--text mt-2 pa-1 rounded-lg text-center" color="#00afa6">
            <v-card-title class="font-weight-bold justify-content-center">Soll Wachstum </v-card-title>
            <span class="h4 font-weight-bold"> <number :to="growthForMonth"></number></span>
          </v-card>
        </v-col>
        <v-col cols="auto">
          <v-card class="mx-2 white--text mt-2 pa-1 rounded-lg text-center" color="#00afa6">
            <v-card-title class="font-weight-bold justify-content-center">IST Wachstum </v-card-title>
            <span v-if="finishedLoadingTerminations" class="h4 font-weight-bold">
              <number :to="newContracts.totalContracts - terminations"></number
            ></span>
            <div v-else>
              <v-progress-circular indeterminate color="white"></v-progress-circular>
            </div>
          </v-card>
        </v-col>
      </v-row>
      <v-row no-gutters>
        <v-col cols="auto">
          <v-card class="mx-2 white--text mt-2 pa-1 rounded-lg text-center" color="#017a8b">
            <v-card-title class="font-weight-bold justify-content-center">Quadratmeter</v-card-title>
            <span class="h4 font-weight-bold"> <number :to="startOfMonth.customersAmount.tac.squareMeter.squareMeterAmount"></number>m² </span>
          </v-card>
        </v-col>
        <v-col cols="auto">
          <v-card class="mx-2 white--text mt-2 pa-1 rounded-lg text-center" color="#017a8b">
            <v-card-title class="font-weight-bold justify-content-center">Mitglieder pro m² </v-card-title>
            <span class="h4 font-weight-bold"> {{ startOfMonth.customersAmount.tac.squareMeter.customerAmount }}</span>
          </v-card>
        </v-col>
        <v-col cols="auto">
          <v-card class="mx-2 white--text mt-2 pa-1 rounded-lg text-center" color="#266074">
            <v-card-title class="font-weight-bold justify-content-center"
              >Stellenprozent ({{ $moment(datePickerRange[0]).format("DD.MMM") }})
            </v-card-title>
            <span class="h4 font-weight-bold"> <number :to="startOfMonth.customersAmount.tac.percentage.percentageAmount"></number>% </span>
          </v-card>
        </v-col>
        <v-col cols="auto">
          <v-card class="mx-2 white--text mt-2 pa-1 rounded-lg text-center" color="#266074">
            <v-card-title class="font-weight-bold justify-content-center">Stellenprozent Aktuell</v-card-title>
            <span class="h4 font-weight-bold"> <number :to="totalPercentages"></number>% </span>
          </v-card>
        </v-col>
        <v-col cols="auto">
          <v-card class="mx-2 white--text mt-2 pa-1 rounded-lg text-center" color="#266074">
            <v-card-title class="font-weight-bold justify-content-center">Mitglieder pro 100% </v-card-title>
            <span class="h4 font-weight-bold"> <number :to="startOfMonth.customersAmount.tac.percentage.customerAmount * 100"></number></span>
          </v-card>
        </v-col>
      </v-row>
      <v-card-title class="font-weight-bold">Monatsziele der Trainer</v-card-title>
      <v-data-table
        dark
        :search="search"
        :loading="!finishedLoading"
        :headers="groupfitnessCoursesTable"
        no-data-text="Keine Trainer gefunden..."
        loading-text="Trainerstatistiken werden geladen..."
        :items="filteredDashboardTrainerInfos"
        :items-per-page="8"
        class="elevation-5 trainer-statistics__table">
        <template v-slot:top>
          <v-row>
            <v-col style="flex-grow: 2">
              <v-text-field v-model="search" class="mx-4" label="Suche"></v-text-field>
            </v-col>
            <v-col style="align-self: center">
              <v-tooltip bottom>
                <div class="d-flex flex-column">
                  <span>Ausgeblendete Mitarbeiter (kein Vertrag, TP, und Anamnese):</span>
                  <p v-for="trainer of notShownTrainers" :key="'notshown' + trainer._id">
                    {{ trainer.fullName }}
                  </p>
                  <span v-if="!notShownTrainers.length">Es wurde kein Trainer ausgeblendet</span>
                </div>
                <template v-slot:activator="{ props, on }">
                  <v-btn v-bind="props" v-on="on" icon color="white">
                    <v-icon color="white">mdi-information</v-icon>
                  </v-btn>
                </template>
              </v-tooltip>
            </v-col>
          </v-row>
        </template>

        <!-- Stellenprozent (unverändert) -->
        <template v-slot:item.percentage="{ item }">
          <v-tooltip bottom>
            <div class="d-flex flex-column">
              <span>Stellenprozent Berechnung:</span>
              <span v-for="(pItem, idx) in item.allPercentages" :key="pItem._id + item.fullName + idx">
                {{ (storeStudios.find((s) => s._id === pItem._id)?.name || "zus. Team") + " " + pItem.percentage + "%" }}
              </span>
            </div>
            <template v-slot:activator="{ props, on }">
              <v-chip color="grey" v-bind="props" v-on="on" style="min-width: 50%" class="justify-content-center font-weight-bold" dark>
                {{ item.percentage + "%" }}
              </v-chip>
            </template>
          </v-tooltip>
        </template>

        <!-- Verträge mit Ziel -->
        <template v-slot:item.contracts="{ item }">
          <v-tooltip bottom>
            <div>
              <p v-for="(count, name) in item.studios" :key="name">{{ name }}: {{ count }}</p>
            </div>
            <template v-slot:activator="{ props, on }">
              <v-chip
                v-bind="props"
                v-on="on"
                :color="getTargetColor(item.contracts, item.trainerGoal?.goals.contracts)"
                style="min-width: 50%"
                class="justify-content-center font-weight-bold"
                dark>
                {{ item.contracts }} / {{ item.trainerGoal?.goals.contracts ?? "-" }}
              </v-chip>
            </template>
          </v-tooltip>
        </template>

        <!-- Ø Pakete (unverändert) -->
        <template v-slot:item.avgPackages="{ item }">
          <v-tooltip bottom>
            <div>
              <p>Gesamt verkauft: {{ Math.round(item.avgPackages * item.contracts) }}</p>
            </div>
            <template v-slot:activator="{ props, on }">
              <v-chip
                v-bind="props"
                v-on="on"
                :color="getPackageColor(item.avgPackages)"
                style="min-width: 50%"
                class="justify-content-center font-weight-bold"
                dark>
                {{ item.avgPackages }}
              </v-chip>
            </template>
          </v-tooltip>
        </template>

        <!-- Pakete (Anzahl) mit Ziel -->
        <template v-slot:item.packageCount="{ item }">
          <v-chip
            :color="getTargetColor(item.packageCount, item.trainerGoal?.goals.packages)"
            style="min-width: 50%"
            class="justify-content-center font-weight-bold"
            dark>
            {{ item.packageCount }} / {{ item.trainerGoal?.goals.packages ?? "-" }}
          </v-chip>
        </template>

        <!-- Anamnesebögen mit Ziel -->
        <template v-slot:item.medicalHistory="{ item }">
          <v-chip
            :color="getTargetColor(item.medicalHistory, item.trainerGoal?.goals.anamneses)"
            style="min-width: 50%"
            class="justify-content-center font-weight-bold"
            dark>
            {{ item.medicalHistory }} / {{ item.trainerGoal?.goals.anamneses ?? "-" }}
          </v-chip>
        </template>

        <!-- Trainingspläne mit Ziel -->
        <template v-slot:item.workouts="{ item }">
          <v-chip
            :color="getTargetColor(item.workouts, item.trainerGoal?.goals.workouts)"
            style="min-width: 50%"
            class="justify-content-center font-weight-bold"
            dark>
            {{ item.workouts }} / {{ item.trainerGoal?.goals.workouts ?? "-" }}
          </v-chip>
        </template>

        <!-- Versch. Kunden TP mit Ziel -->
        <template v-slot:item.workoutsPerCustomer="{ item }">
          <v-chip
            :color="getTargetColor(item.workoutsPerCustomer, item.trainerGoal?.goals.workoutsPerCustomer)"
            style="min-width: 50%"
            class="justify-content-center font-weight-bold"
            dark>
            {{ item.workoutsPerCustomer }} / {{ item.trainerGoal?.goals.workoutsPerCustomer ?? "-" }}
          </v-chip>
        </template>

        <!-- Kundeninteraktionen mit Ziel -->
        <template v-slot:item.interactions.totalInteractions="{ item }">
          <v-chip
            :color="getTargetColor(item.interactions.totalInteractions, item.trainerGoal?.goals.interactions)"
            style="min-width: 50%"
            class="justify-content-center font-weight-bold"
            dark>
            {{ item.interactions.totalInteractions }} /
            {{ item.trainerGoal?.goals.interactions ?? "-" }}
          </v-chip>
        </template>

        <!-- Termine mit Ziel -->
        <template v-slot:item.appointments="{ item }">
          <v-chip
            :color="getTargetColor(item.trainerGoal?.goals.appointmentsActual, item.trainerGoal?.goals.appointmentsTarget)"
            style="min-width: 50%"
            class="justify-content-center font-weight-bold"
            dark>
            {{ item.trainerGoal?.goals.appointmentsActual ?? 0 }} / {{ item.trainerGoal?.goals.appointmentsTarget ?? "-" }}
          </v-chip>
        </template>

        <!-- Upgrades mit Ziel -->
        <template v-slot:item.upgrades="{ item }">
          <v-chip
            :color="getTargetColor(item.upgrades, item.trainerGoal?.goals.upgrades)"
            style="min-width: 50%"
            class="justify-content-center font-weight-bold"
            dark>
            {{ item.upgrades }} / {{ item.trainerGoal?.goals.upgrades ?? "-" }}
          </v-chip>
        </template>
      </v-data-table>
      <v-card-title class="font-weight-bold"
        >11-Tage-Statistiken <span class="h6 my-auto ml-4">(20% unter Durchschnitt Rot, 20% über Durchschnitt Grün)</span></v-card-title
      >
      <v-data-table
        dark
        :loading="!finishedLoadingElevenDaysData"
        :headers="elevenDaysHeaders"
        :items="elevenDaysData"
        class="elevation-5 eleven-days-table"
        :items-per-page="8">
        <template v-slot:item.activated="{ item }">
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-chip v-bind="attrs" v-on="on" :color="getDeviationColor(item.activated, averages.activated)" class="font-weight-bold" dark>
                {{ item.activated }}
              </v-chip>
            </template>
            <span>Ø Aktiviert: {{ Math.round(averages.activated) }}</span>
          </v-tooltip>
        </template>

        <!-- Abgeschlossen -->
        <template v-slot:item.accepted="{ item }">
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-chip v-bind="attrs" v-on="on" :color="getDeviationColor(item.accepted, averages.accepted)" class="font-weight-bold" dark>
                {{ item.accepted }}
              </v-chip>
            </template>
            <span>Ø Abgeschlossen: {{ Math.round(averages.accepted) }}</span>
          </v-tooltip>
        </template>

        <!-- Kein Abschluss -->
        <template v-slot:item.declined="{ item }">
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-chip v-bind="attrs" v-on="on" :color="getDeviationColor(item.declined, averages.declined)" class="font-weight-bold" dark>
                {{ item.declined }}
              </v-chip>
            </template>
            <span>Ø Kein Abschluss: {{ Math.round(averages.declined) }}</span>
          </v-tooltip>
        </template>

        <!-- Anamnese -->
        <template v-slot:item.anamnese="{ item }">
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-chip v-bind="attrs" v-on="on" :color="getDeviationColor(item.anamnese, averages.anamnese)" class="font-weight-bold" dark>
                {{ item.anamnese }}
              </v-chip>
            </template>
            <span>Ø Anamnese: {{ Math.round(averages.anamnese) }}</span>
          </v-tooltip>
        </template>

        <!-- Anamnese 11 Tage -->
        <template v-slot:item.anamneseEleven="{ item }">
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-chip v-bind="attrs" v-on="on" :color="getDeviationColor(item.anamneseEleven, averages.anamneseEleven)" class="font-weight-bold" dark>
                {{ item.anamneseEleven }}
              </v-chip>
            </template>
            <span>Ø Anamnese 11 Tage: {{ Math.round(averages.anamneseEleven) }}</span>
          </v-tooltip>
        </template>

        <!-- Quote -->
        <template v-slot:item.quote="{ item }">
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-chip v-bind="attrs" v-on="on" :color="getDeviationColor(parseFloat(item.quote), averages.quote)" class="font-weight-bold" dark>
                {{ Math.round(parseFloat(item.quote)) }}%
              </v-chip>
            </template>
            <span>Ø Quote: {{ Math.round(averages.quote) }}%</span>
          </v-tooltip>
        </template>
      </v-data-table>

      <v-card-title class="font-weight-bold">Überstunden und Ferienstunden</v-card-title>
      <v-data-table
        dark
        chips
        :headers="overtimeVacationHeaders"
        :items="overtimeVacationItems"
        class="elevation-5 overtime-vacation-table"
        :items-per-page="8">
        <template v-slot:item.percentage="{ item }">
          <v-chip class="ma-2">{{ item.percentage }}%</v-chip>
        </template>
        <template v-slot:item.overTime="{ item }">
          <v-chip class="ma-2">{{ item.overTime }}</v-chip>
        </template>
        <template v-slot:item.vacationHours="{ item }">
          <v-chip class="ma-2" v-if="item.vacationHours !== 'keine hinterlegt'">
            {{ Math.round(item.vacationHours * 10) / 10 }}h |
            {{ Math.round((item.vacationHours / ((8.4 / 100) * item.timeTrackerPercentage)) * 10) / 10 + " Tage" }}
          </v-chip>
          <v-chip class="ma-2" v-else>keine hinterlegt</v-chip>
        </template>
        <template v-slot:item.vacationDaysCount="{ item }">
          <v-tooltip bottom>
            <template v-slot:activator="{ attrs, on }">
              <v-chip v-bind="attrs" v-on="on" class="ma-2">{{ item.vacationDaysCount }} Tage</v-chip>
            </template>
            <div v-for="date in item.vacationDatesList" :key="date.date">{{ $moment(date.date).format("DD.MM.YYYY") + " " + date.reason }}</div>
          </v-tooltip>
        </template>
      </v-data-table>
    </div>
  </div>
</template>

<script>
import api from "../../../api"
import { mapState } from "vuex"
import userService from "@/services/userService.js"

export default {
  name: "dashboard",
  props: {
    selectedStudioSingle: { type: String },
    datePickerRange: { type: Array },
  },
  data() {
    return {
      userService,
      tab: 0,
      notShownTrainers: [],
      activeSorting: "",
      search: "",
      percentagesTo100: false,
      dashboardTrainerInfos: [],
      finishedLoading: false,
      showTargetDialog: false,
      selectedTrainer: null,
      finishedLoadingTerminations: false,
      finishedLoadingElevenDaysData: false,
      startOfMonth: {},
      newContracts: { totalContracts: 0, publicContracts: 0 },
      terminations: null,
      growthForMonth: null,
      elevenDaysData: [],
      targets: {},
      workHours: "",
      elevenDaysHeaders: [
        { text: "Trainer", value: "trainer" },
        { text: "Anz. 11 Tage Aktiviert", value: "activated" },
        { text: "Abgeschlossen", value: "accepted" },
        { text: "Kein Abschluss", value: "declined" },
        { text: "Anamnese", value: "anamnese" },
        { text: "Anamnese 11. Tage", value: "anamneseEleven" },
        { text: "Quote", value: "quote" },
        { text: "Quote (studio)", value: "studioQuote" },
      ],
      sortItems: [
        { text: "Anz. Anamnese", value: "medicalHistory" },
        { text: "Interaktionen", value: "interactions" },
        { text: "Anz. Trainingspläne", value: "workouts" },
        { text: "Anz. Verträge", value: "contracts" },
        { text: "Ø Pakete", value: "avgPackages" },
        { text: "Pakete", value: "packageCount" },
      ],
      groupfitnessCoursesTable: [
        { text: "Name", value: "fullName" },
        { text: "Stellenprozent", value: "percentage" },
        { text: "Verträge", value: "contracts" },
        { text: "Pakete", value: "packageCount" },
        { text: "Anamnesebögen", value: "medicalHistory" },
        { text: "Trainingspläne", value: "workouts" },
        { text: "Versch. Kunden TP", value: "workoutsPerCustomer" },
        { text: "Kundeninteraktionen", value: "interactions.totalInteractions" },
        { text: "Termine", value: "appointments" },
        { text: "Upgrades", value: "upgrades" },
      ],
      overtimeVacationHeaders: [
        { text: "Trainer", value: "fullName" },
        { text: "Stellenprozent", value: "percentage" },
        { text: "Überstunden in (h)", value: "overTime" },
        { text: "Ferienstunden", value: "vacationHours" },
        { text: "Urlaubstage im " + this.$moment(this.datePickerRange[0]).format("MMM YY"), value: "vacationDaysCount" },
      ],
      trainerVacations: null,
      totalPercentages: 0,
    }
  },
  created() {
    this.fetchData()
    this.fetchTerminations()
    this.fetchElevenDaysData()
  },
  methods: {
    async fetchData() {
      this.finishedLoading = false
      let data = await api.fetchMontlyStatistcsForStudio(this.selectedStudioSingle, this.$moment(this.datePickerRange[0]).format("YYYY-MM"))
      this.startOfMonth = data.startOfMonthStat[0]
      this.growthForMonth = data.growthForMonth
      this.newContracts = data.contracts[0]
      this.trainerVacations = await api.fetchHolidayEntryEmployeeStudioManagement(this.selectedStudioSingle, "accepted")
      this.dashboardTrainerInfos = await api.fetchTrainerDashboardInfos({
        studios: [this.selectedStudioSingle],
        range: this.datePickerRange,
      })
      this.notShownTrainers = this.dashboardTrainerInfos.filter((t) => !t.contracts && !t.workouts && !t.medicalHistory)
      // this.dashboardTrainerInfos = this.dashboardTrainerInfos.filter((t) => t.contracts || t.workouts || t.medicalHistory)
      this.finishedLoading = true
    },
    async fetchElevenDaysData() {
      this.finishedLoadingElevenDaysData = false
      try {
        let data = await api.fetchMontlyStatistcsElevenDaysForStudio(
          this.selectedStudioSingle,
          this.$moment(this.datePickerRange[0]).format("YYYY-MM")
        )
        this.elevenDaysData = data
      } catch (error) {
        this.$toast.error("Fehler beim Laden der 11 Tage Daten")
      }
      this.finishedLoadingElevenDaysData = true
    },
    async fetchTerminations() {
      this.finishedLoadingTerminations = false
      let data = await api.fetchMonthlyStatistcsForStudioTerminations(
        this.selectedStudioSingle,
        this.$moment(this.datePickerRange[0]).format("YYYY-MM")
      )
      this.terminations = data.terminations
      this.finishedLoadingTerminations = true
    },
    getTargetColor(actual, target) {
      if (target == null || target === 0) return "grey"
      const ratio = actual / target
      if (ratio <= 0.5) return "red"
      if (ratio < 1) return "orange"
      return "green"
    },
    // Farb-Helper für Ø Pakete, Quote bleiben unverändert
    getPackageColor(val) {
      if (val > this.packagesOnAverage + 0.5) return "green"
      if (val < this.packagesOnAverage - 0.5) return "red"
      return "orange"
    },
    getDeviationColor(value, avg) {
      return ""
      return "grey"
      if (value >= avg * 1.2) return "green"
      if (value <= avg * 0.8) return "red"
      return "orange"
    },
  },
  computed: {
    ...mapState("studioStore", ["storeStudios"]),
    overtimeVacationItems() {
      const start = this.$moment(this.datePickerRange[0]).startOf("month")
      const end = this.$moment(this.datePickerRange[0]).endOf("month")
      return this.dashboardTrainerInfos.map((trainer) => {
        console.log("Trainer:", trainer)
        // Alle Urlaubseinträge für diesen Trainer
        const vacEntries = this.trainerVacations.filter((v) => v.employee.fullName === trainer.fullName && v.dates?.length > 0)
        // Sammle alle relevanten Urlaubsdaten im Monat
        let vacationDatesList = []
        vacEntries.forEach((entry) => {
          entry.dates.forEach((d) => {
            if (this.$moment(d.date).isBetween(start, end, "day", "[]")) {
              if (d.duration > 0) vacationDatesList.push({ date: d.date, reason: entry.reason || "kein Grund angegeben" })
            }
          })
        })
        return {
          fullName: trainer.fullName,
          percentage: trainer.percentage,
          timeTrackerPercentage: trainer.timeTrackerPercentage || trainer.percentage,
          overTime: trainer.overTime || "keine hinterlegt",
          vacationHours: trainer.mainStudio?.vacationHours || "keine hinterlegt",
          vacationDaysCount: vacationDatesList.length,
          vacationDatesList,
        }
      })
    },
    averages() {
      const sums = this.elevenDaysData.reduce(
        (acc, cur) => {
          acc.activated += cur.activated
          acc.accepted += cur.accepted
          acc.declined += cur.declined
          acc.anamnese += cur.anamnese
          acc.anamneseEleven += cur.anamneseEleven
          acc.quote += parseFloat(cur.quote)
          acc.studioQuote += cur.studioQuote
          return acc
        },
        { activated: 0, accepted: 0, declined: 0, anamnese: 0, anamneseEleven: 0, quote: 0, studioQuote: 0 }
      )
      const len = this.elevenDaysData.length || 1
      return {
        activated: sums.activated / len,
        accepted: sums.accepted / len,
        declined: sums.declined / len,
        anamnese: sums.anamnese / len,
        anamneseEleven: sums.anamneseEleven / len,
        quote: sums.quote / len,
        studioQuote: sums.studioQuote / len,
      }
    },
    getContractCount() {
      let studioName = this.storeStudios.find((s) => s._id === this.selectedStudioSingle)?.name

      if (studioName) {
        return this.dashboardTrainerInfos.reduce((acc, trainer) => {
          const studioCount = trainer.studios[studioName] || 0
          return acc + studioCount
        }, 0)
      } else {
        this.$toast.error("Neuverträge konnten nicht geladen werden.")
        return 0
      }
    },
    filteredDashboardTrainerInfos() {
      let arr = JSON.parse(JSON.stringify(this.dashboardTrainerInfos))
      let totalPercentages = 0
      arr = arr.map((u) => {
        u.studio = u.studio.map((id) => this.storeStudios.find((s) => s._id === id)?.name || "zus. Team").join(", ")
        totalPercentages += u.allPercentages.find((p) => p._id === this.selectedStudioSingle)?.percentage || 0
        if (this.percentagesTo100 && u.percentage < 100) {
          u.contracts = Math.round((u.contracts / u.percentage) * 100)
          u.interactions.totalInteractions = Math.round((u.interactions.totalInteractions / u.percentage) * 100)
          u.medicalHistory = Math.round((u.medicalHistory / u.percentage) * 100)
          u.workouts = Math.round((u.workouts / u.percentage) * 100)
          u.workoutsPerCustomer = Math.round((u.workoutsPerCustomer / u.percentage) * 100)
          u.upgrades = Math.round((u.upgrades / u.percentage) * 100)
          u.percentage = 100
        }
        return u
      })
      arr = arr.filter((u) => !u.fullName.toLowerCase().includes("roodytrainer"))
      if (this.activeSorting) {
        arr.sort((a, b) => b[this.activeSorting] - a[this.activeSorting])
      }
      this.totalPercentages = totalPercentages
      return arr
    },
  },
  watch: {
    async selectedStudioSingle() {
      this.fetchData()
      this.fetchTerminations()
      this.fetchElevenDaysData()
    },
    async datePickerRange() {
      if (this.datePickerRange[0] && this.datePickerRange[1]) {
        this.fetchData()
        this.fetchTerminations()
        this.fetchElevenDaysData()
      }
    },
  },
}
</script>

<style lang="scss" scoped>
::v-deep .apexcharts-menu-open {
  background-color: #212121 !important;
  height: 80vh;
}
.trainer-statistics {
  &__table {
    width: 100%;
  }
}
</style>
